import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CheckIcon from "@mui/icons-material/Check";

import Button from "../../components/Button";

interface ConfirmProps {
  open?: boolean;
  title: string;
  children: ReactNode;
  onConfirm: (result: boolean) => void;
  confirmColor?: "success" | "error" | "info" | "warning";
  notification?: boolean;
}

const Confirm: FC<ConfirmProps> = ({ open = true, title, children, onConfirm, confirmColor = "success", notification = false }) => {
  const { t } = useTranslation();
  const close = () => onConfirm(false);

  return (
    <Dialog open={open} onClose={close}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent style={{ lineHeight: 1.4 }}>{children}</DialogContent>
      <DialogActions>
        {notification ? (
          <Button title={t("close_dialog")} onClick={close} color="info" startIcon={<CheckIcon />} variant="contained">
            {t("ok")}
          </Button>
        ) : (
          <>
            <Button title={t("cancel_action")} autoFocus onClick={close}>
              {t("cancel")}
            </Button>
            <Button
              title={t("confirm_action")}
              onClick={() => onConfirm(true)}
              variant="contained"
              color={confirmColor}
              startIcon={<CheckIcon />}
            >
              {t("confirm")}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default Confirm;
